// extracted by mini-css-extract-plugin
export default {"enabled":"index-module__WtFLE","disabled":"index-module__wC6RT","action":"index-module__YXffv","icon":"index-module__JwGbJ"};